var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="CDB-Widget-contentFlex u-rSpace--xl">\n  <button class="CDB-Text is-semibold u-upperCase CDB-Size-small u-rSpace--m js-searchToggle u-actionTextColor">cancel</button>\n</div>\n';
 if (showPaginator) { ;
__p += '\n  <div class="CDB-Widget-navDots js-dots u-tSpace--m">\n    ';
 for (var i = 0, l = pages; i < l; i++) { ;
__p += '<button class="CDB-Shape-dot CDB-Widget-dot--navigation js-page ';
 if (currentPage === i) { ;
__p += 'is-selected';
 } ;
__p += '" data-page="' +
__e( i ) +
'"></button>';
 } ;
__p += '\n  </div>\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/deep-insights/widgets/category/paginator/search-paginator-template.tpl
// module id = 913
// module chunks = 0 2